import { Routes, Route } from 'react-router-dom';
import FrauMeetsBoersePage from '@/components/frauMeetsBoerse/FrauMeetsBoersePage';
import FmbVideosPage from '@/components/frauMeetsBoerse/FmbVideosPage';
import FmbLegalPage from '@/components/frauMeetsBoerse/FmbLegalPage';
import { FRAU_MEETS_BOERSE_CONFIG } from '@/consts/frauMeetsBoerse';
import { impressumContent } from '@/content/legal/impressum';
import { datenschutzContent } from '@/content/legal/datenschutz';
import { risikoDisclaimerContent } from '@/content/legal/risikodisclaimer';

/**
 * Routen-Baum für die externen Frau-meets-Börse-Domains (Reverse Proxy).
 * Der Catch-all rendert die Landingpage für jeden Pfad (auch '/') —
 * AuthRouter/AppRouter werden auf diesen Hosts nie gemountet, ein
 * Login-Redirect ist damit ausgeschlossen. Nur die Umsetzungsvideos-Unterseite
 * und die rechtlich nötigen Seiten (Footer-Links) bleiben als eigene Routen
 * erreichbar — im selben Design wie die Landingpage.
 */
export default function FmbHostRouter() {
  return (
    <Routes>
      <Route path={FRAU_MEETS_BOERSE_CONFIG.videosPath} element={<FmbVideosPage />} />
      <Route path="/impressum" element={<FmbLegalPage content={impressumContent} />} />
      <Route path="/datenschutz" element={<FmbLegalPage content={datenschutzContent} />} />
      <Route path="/risikodisclaimer" element={<FmbLegalPage content={risikoDisclaimerContent} />} />
      <Route path="*" element={<FrauMeetsBoersePage />} />
    </Routes>
  );
}

/**
 * Unterseiten der Frau-meets-Börse-Landingpage für die Hauptdomain
 * (unterhalb der Landingpage-Route, z. B. /frau-meets-boerse/webinar oder
 * /frau-meets-boerse/impressum). Wird in AuthRouter und AppRouter eingehängt,
 * damit die Umsetzungsvideos- und Footer-Links der Landingpage dort im selben
 * Design bleiben und nicht in das Börsencampus-Design wechseln.
 */
export function FmbSubRoutes() {
  const base = FRAU_MEETS_BOERSE_CONFIG.routePath;
  return (
    <>
      <Route path={`${base}${FRAU_MEETS_BOERSE_CONFIG.videosPath}`} element={<FmbVideosPage />} />
      <Route path={`${base}/impressum`} element={<FmbLegalPage content={impressumContent} />} />
      <Route path={`${base}/datenschutz`} element={<FmbLegalPage content={datenschutzContent} />} />
      <Route path={`${base}/risikodisclaimer`} element={<FmbLegalPage content={risikoDisclaimerContent} />} />
    </>
  );
}
